export { default } from "./MTHero";
